import { render, staticRenderFns } from "./batchingSurcharge.vue?vue&type=template&id=96445608&scoped=true&"
import script from "./batchingSurcharge.vue?vue&type=script&lang=js&"
export * from "./batchingSurcharge.vue?vue&type=script&lang=js&"
import style0 from "./batchingSurcharge.vue?vue&type=style&index=0&id=96445608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96445608",
  null
  
)

export default component.exports